// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"a29ff5cd","288":"60f4e7e4","304":"253877fd","344":"194b0c44","392":"1948e844","400":"41450536","412":"f1a9b0e4","576":"bb542c78","688":"a93c1778","760":"73d94d8b","896":"17b0fc43","916":"6eeedb5d","984":"248f69bb"}[chunkId] + ".chunk.js";
};